// React Query caches by key alone: two observers sharing one key share one
// cache entry, and whichever fetch lands first defines the shape both see.
// EventBooking's ['user-ticket', …] caches a single object (.maybeSingle());
// BookedEventActions' key caches an array of confirmed tickets. Keep them in
// one module so a shape collision fails the key-distinctness test.
export const userTicketQueryKey = (eventId: string) => ['user-ticket', eventId] as const;
export const userTicketsBookedQueryKey = (eventId: string) => ['user-tickets-booked', eventId] as const;
